/**
 * "Propagate again from this directory" (S8 Task 8.11, row R3 — `failedDirectoryChildrenVisited: false`): a failed
 * directory whose children Azure skipped gets a NEW recursive job rooted there, through the Propagate dialog (its own
 * root check, approval and typed name), pre-filled with the failed job's change.
 */
import type { HnsAclFailure, TransferJob } from '../../../types/azureStorage';
import { useStorageDialogStore } from '../../workspace/storage-explorer/properties/dialogs/storageDialogStore';

export function propagateAgainFromFailure(job: TransferJob, failure: HnsAclFailure): void {
  const acl = job.acl;
  if (!acl || !failure.isDirectory) return;
  useStorageDialogStore.getState().openDialog({
    kind: 'hns-acl-propagate',
    connectionId: job.connectionId,
    resource: { kind: 'hnsPath', fileSystem: acl.target.fileSystem, path: failure.path, isDirectory: true },
    source: 'panel',
    hns: { origin: 'notice', propagateChange: acl.change },
  });
}
